import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdPerson, MdLogout, MdLightMode, MdDarkMode, MdMenu, MdClose } from 'react-icons/md';
import { RiArrowDownSLine as ChevronDown } from 'react-icons/ri';
import './styles.css';
import lg1Logo from '../../assets/lg1.png';
import lg2Logo from '../../assets/lg2.png';
import { getStoredUser, clearAuthSession } from '../../utils/authSession';
import { useTheme } from '../../context/ThemeContext';

const Navbar = ({ sidebarOpen = false, onToggleSidebar }) => {
  const navigate = useNavigate();
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const { isDark, toggleTheme } = useTheme();

  const user = getStoredUser();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    clearAuthSession();
    setUserMenuOpen(false);
    navigate('/login', { replace: true });
  };

  return (
    <nav className="top-navbar">
      <div className="navbar-content">
        <div className="navbar-left">
          {typeof onToggleSidebar === 'function' && (
            <button
              type="button"
              className="navbar-menu-btn"
              onClick={onToggleSidebar}
              aria-label={sidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={sidebarOpen}
              aria-controls="app-sidebar"
            >
              {sidebarOpen ? <MdClose size={22} /> : <MdMenu size={22} />}
            </button>
          )}
          <img src={lg1Logo} alt="Logo 1" className="navbar-logo-left" />
        </div>
        <div className="navbar-center" />
        <div className="navbar-right">
        <img src={lg2Logo} alt="Logo 2" className="navbar-logo-right" />
          <button
            type="button"
            className="theme-toggle-btn"
            onClick={toggleTheme}
            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDark ? <MdLightMode size={20} /> : <MdDarkMode size={20} />}
            <span className="theme-toggle-label">{isDark ? 'Light' : 'Dark'}</span>
          </button>
          {user && (
            <div className="navbar-user-menu" ref={menuRef}>
              <button
                type="button"
                className="navbar-user-trigger"
                onClick={() => setUserMenuOpen((o) => !o)}
                aria-expanded={userMenuOpen}
                aria-haspopup="true"
                aria-label="User menu"
              >
                <span className="navbar-user-avatar">
                  <MdPerson size={20} />
                </span>
                <span className="navbar-user-name">{user.name}</span>
                <ChevronDown size={18} className={`navbar-user-chevron ${userMenuOpen ? 'open' : ''}`} />
              </button>
              {userMenuOpen && (
                <div className="navbar-user-dropdown">
                  <div className="navbar-user-dropdown-header">
                    <span className="navbar-user-dropdown-email">{user.email}</span>
                  </div>
                  <button type="button" className="navbar-user-dropdown-item logout" onClick={handleLogout}>
                    <MdLogout size={18} />
                    <span>Log out</span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
